import { IAction, ActionType } from "../actions/actiontype";
import * as _ from 'lodash';
import * as Classes from "../../../classes/index"
import { updateArray } from "../../../helpers/index";
import { IFormSubmissionDto } from "../../../classes/index";

export interface StepOneModel {
    basicInformation: Classes.IBasicInformation;
    parentInformation: Classes.IParentInformation;
    siblings: Array<Classes.ISibling>;
    aboutMyChild: Classes.IAboutMyChild;
}

export const defaultStepOneModel: StepOneModel = {
    basicInformation: Classes.defaultBasicInformation,
    parentInformation: Classes.defaultParentInformation,
    siblings: [],
    aboutMyChild: Classes.defaultAboutMyChild
};

export default function stepOneReducer(state: StepOneModel = defaultStepOneModel, action: IAction) {
    switch (action.type) {
        case ActionType.EXISTING_DATA_RECEIVED: {
            const value = action.value as IFormSubmissionDto;

        }

        case ActionType.SAVE_BASIC_INFORMATION: {
            const answer: Classes.IFormAnswer = action.value;
            let updatedBasicInformation = _.assign({}, state.basicInformation);
            updatedBasicInformation[answer.id] = answer.value;
            return _.assign({}, state, { basicInformation: updatedBasicInformation });
        }
        case ActionType.NEW_PARENT: {
            const currentParents = state.parentInformation.parents;
            const parentCount = state.parentInformation.parents.length;
            // Need to create a brand new object, or else the reference is kept.
            let updatedParents = [...currentParents.slice(0, parentCount), Classes.defaultParent];

            return _.assign({}, state, { parentInformation: _.assign({}, state.parentInformation, { parents: updatedParents }) });
        }
        case ActionType.SAVE_PARENT: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let newParentsArray = updateArray<Classes.IParent>(state.parentInformation.parents, idx, data);

            return _.assign({}, state, { parentInformation: _.assign({}, state.parentInformation, { parents: newParentsArray }) });
        }

        case ActionType.REMOVE_PARENT: {
            const idx = action.value as number;

            let parentsArray: Classes.IParent[];
            parentsArray = [...state.parentInformation.parents.slice(0, state.parentInformation.parents.length - 1)];

            return _.assign({}, state, {
                parentInformation: _.assign({}, state.parentInformation, { parents: parentsArray })
            });
        }

        case ActionType.CHANGE_CORRESPONDENCE: {
            let number = action.value as string;

            let newParentInformation = _.assign({}, state.parentInformation);
            newParentInformation.sendCorrespondenceTo = number;

            return _.assign({}, state, { parentInformation: newParentInformation });
        }
        case ActionType.NEW_SIBLING: {
            const currentSiblings = state.siblings;
            const siblingCount = state.siblings.length;
            // Need to create a brand new object, or else the reference is kept.
            let updatedSiblings = [...currentSiblings.slice(0, siblingCount), _.assign({}, Classes.defaultSibling, { key: siblingCount })];

            return _.assign({}, state, { siblings: updatedSiblings });
        }
        case ActionType.SAVE_SIBLING: {
            let idx = action.value.idx as number;
            let data: Classes.IFormAnswer = action.value.data;

            let newSiblingsArray = updateArray<Classes.ISibling>(state.siblings, idx, data);

            return _.assign({}, state, { siblings: newSiblingsArray });
        }

        case ActionType.REMOVE_SIBLING: {
            const idx = action.value as number;

            let siblingsArray: Classes.ISibling[];
            if (idx < state.siblings.length) {
                siblingsArray = [...state.siblings.slice(0, idx), ...state.siblings.slice(idx + 1)];
            } else {
                siblingsArray = [...state.siblings.slice(0, state.siblings.length - 1)];
            }

            return _.assign({}, state, {
                siblings: siblingsArray
            });
        }

        case ActionType.SAVE_ABOUT_MY_CHILD: {
            let data: Classes.IFormAnswer = action.value;
            let updatedAboutMyChild = _.assign({}, state.aboutMyChild);
            updatedAboutMyChild[data.id] = data.value;

            return _.assign({}, state, { aboutMyChild: updatedAboutMyChild });
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/camp-sign-up/redux/reducers/step-one-reducer.ts